import { Currency } from 'common/types/format';
import { SET_CURRENCY } from './types';

export const setCurrency = (currency?: Currency) => ({
  type: SET_CURRENCY,
  currency,
});
